// Pre-defined social network logos as inline SVG data URIs
// These are small, reliable, and work without CORS issues

function svgToDataUri(svg) {
  return "data:image/svg+xml;base64," + btoa(svg);
}

export const PRESET_LOGOS = [
  {
    id: "facebook",
    name: "Facebook",
    color: "#1877F2",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#1877F2"/><path d="M62 30h-7c-5.5 0-10 4.5-10 10v7h-7v10h7v25h10V57h7l3-10h-10v-5c0-1.7 1.3-3 3-3h7V30z" fill="#fff"/></svg>'),
  },
  {
    id: "instagram",
    name: "Instagram",
    color: "#E4405F",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><linearGradient id="ig" x1="0" y1="1" x2="1" y2="0"><stop offset="0%" stop-color="#FFDC80"/><stop offset="25%" stop-color="#F77737"/><stop offset="50%" stop-color="#E4405F"/><stop offset="75%" stop-color="#C13584"/><stop offset="100%" stop-color="#833AB4"/></linearGradient></defs><circle cx="50" cy="50" r="50" fill="url(#ig)"/><rect x="25" y="25" width="50" height="50" rx="14" fill="none" stroke="#fff" stroke-width="5"/><circle cx="50" cy="50" r="11" fill="none" stroke="#fff" stroke-width="4.5"/><circle cx="65" cy="35" r="3.5" fill="#fff"/></svg>'),
  },
  {
    id: "x-twitter",
    name: "X / Twitter",
    color: "#000000",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#000"/><path d="M58.2 32h7.3L52.7 47.6 68 68h-12l-9.2-12L36 68h-7.3l13.7-15.6L30 32h12.3l8.3 11L58.2 32zm-2.6 32.4h4L40.6 36h-4.3l19.3 28.4z" fill="#fff"/></svg>'),
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    color: "#0A66C2",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#0A66C2"/><path d="M35 42h-8v28h8V42zm-4-13c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm38 13h-7.5c-3.5 0-5 2-5.5 3.5V42H48v28h8V56c0-3 1.5-5 4.5-5S64 53 64 56v14h8V50c0-5-3-8-3-8z" fill="#fff"/></svg>'),
  },
  {
    id: "youtube",
    name: "YouTube",
    color: "#FF0000",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#FF0000"/><path d="M70 39.5c-.7-2.7-2.8-4.8-5.5-5.5C60.5 33 50 33 50 33s-10.5 0-14.5 1c-2.7.7-4.8 2.8-5.5 5.5C29 43.5 29 50 29 50s0 6.5 1 10.5c.7 2.7 2.8 4.8 5.5 5.5 4 1 14.5 1 14.5 1s10.5 0 14.5-1c2.7-.7 4.8-2.8 5.5-5.5 1-4 1-10.5 1-10.5s0-6.5-1-10.5z" fill="#fff"/><path d="M45 58l12-8-12-8v16z" fill="#FF0000"/></svg>'),
  },
  {
    id: "whatsapp",
    name: "WhatsApp",
    color: "#25D366",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#25D366"/><path d="M50 27c-12.7 0-23 10.3-23 23 0 4.1 1.1 8 3 11.4L27 73l12-3c3.2 1.7 6.8 2.6 10.6 2.6h.4c12.7 0 23-10.3 23-23S62.7 27 50 27zm13.3 32.5c-.6 1.6-3.3 3.1-4.6 3.3-1.2.2-2.7.3-4.4-.3-1-.4-2.4-.8-4.1-1.6-7.2-3.3-11.9-10.6-12.3-11.1-.3-.5-2.8-3.7-2.8-7.1s1.8-5 2.4-5.7c.6-.6 1.3-.8 1.8-.8h1.3c.4 0 1-.2 1.5 1.2.6 1.4 2 4.8 2.1 5.1.2.3.3.7.1 1.1-.2.4-.3.7-.6 1-.3.4-.7.8-1 1.1-.3.3-.7.7-.3 1.4.4.7 1.7 2.8 3.7 4.5 2.5 2.2 4.7 2.9 5.3 3.2.7.3 1.1.3 1.5-.2.4-.5 1.7-2 2.2-2.7.4-.7.9-.6 1.5-.3.6.2 3.9 1.8 4.6 2.2.7.3 1.1.5 1.3.8.2.3.2 1.8-.4 3.4z" fill="#fff"/></svg>'),
  },
  {
    id: "tiktok",
    name: "TikTok",
    color: "#000000",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#000"/><path d="M63 30c0 5.5 4.5 10 10 10v8c-3.5 0-7-1.2-10-3.2V58c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16v8c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8V30h8z" fill="#fff"/></svg>'),
  },
  {
    id: "github",
    name: "GitHub",
    color: "#181717",
    url: svgToDataUri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="#181717"/><path d="M50 25c-13.8 0-25 11.2-25 25 0 11 7.2 20.4 17.1 23.7 1.2.2 1.7-.5 1.7-1.2v-4.2c-7 1.5-8.4-3.4-8.4-3.4-1.1-2.9-2.8-3.6-2.8-3.6-2.3-1.5.2-1.5.2-1.5 2.5.2 3.8 2.6 3.8 2.6 2.2 3.8 5.8 2.7 7.2 2.1.2-1.6.9-2.7 1.6-3.3-5.6-.6-11.4-2.8-11.4-12.4 0-2.7 1-5 2.6-6.7-.3-.6-1.1-3.2.2-6.6 0 0 2.1-.7 6.8 2.5 2-.6 4.1-.8 6.2-.8 2.1 0 4.2.3 6.2.8 4.8-3.2 6.8-2.5 6.8-2.5 1.4 3.4.5 6 .3 6.6 1.6 1.7 2.6 4 2.6 6.7 0 9.6-5.8 11.8-11.4 12.4.9.8 1.7 2.3 1.7 4.7v7c0 .7.5 1.4 1.7 1.2C67.8 70.4 75 61 75 50c0-13.8-11.2-25-25-25z" fill="#fff"/></svg>'),
  },
];

export const DOT_TYPES = [
  { id: "square", name: "Square" },
  { id: "dots", name: "Dots" },
  { id: "rounded", name: "Rounded" },
  { id: "classy", name: "Classy" },
  { id: "classy-rounded", name: "Classy Rounded" },
  { id: "extra-rounded", name: "Extra Rounded" },
];

export const CORNER_SQUARE_TYPES = [
  { id: "square", name: "Square" },
  { id: "dot", name: "Dot" },
  { id: "extra-rounded", name: "Rounded" },
];

export const CORNER_DOT_TYPES = [
  { id: "square", name: "Square" },
  { id: "dot", name: "Dot" },
];

export const COLOR_PRESETS = [
  "#09090B", "#FFFFFF", "#0047FF", "#EF4444", "#F97316",
  "#EAB308", "#22C55E", "#06B6D4", "#8B5CF6", "#EC4899",
  "#78350F", "#1E3A5F", "#064E3B", "#7C2D12",
];

export const DEFAULT_STYLE = {
  fg_color: "#09090B",
  bg_color: "#FFFFFF",
  dot_type: "square",
  corner_square_type: "square",
  corner_dot_type: "square",
  logo_base64: null,
  logo_preset: null,
  bottom_text: "",
  show_review_stars: false,
  review_rating: 5,
};
